<script lang="ts" setup>
import userStore from '@/store/UserStore'
import LanguageSwitcher from '@/components/header/LanguageSwitcher.vue'
import HeaderUser from '@/components/header/HeaderUser.vue'
import EnvironmentHint from '@/components/admin/EnvironmentHint.vue'
import { useRoute } from 'vue-router'
import CountrySwitcher from '@/components/header/CountrySwitcher.vue'
</script>

<template>
  <header class="header">
    <div class="container header__container">
      <router-link to="/">
        <div class="header__title has--pointer">
          <span>{{ $t('global.project_name') }}</span>
        </div>
      </router-link>

      <div class="header__user-wrap">
        <CountrySwitcher v-if="userStore.isPrivileged" />

        <router-link v-if="userStore.isPrivileged" to="/configuration">
          <HeaderUser :user-name="userStore.name" />
        </router-link>
        <HeaderUser v-else :user-name="userStore.name" />
      </div>

      <LanguageSwitcher class="lang-switcher" />
    </div>
  </header>

  <EnvironmentHint v-if="useRoute().path.includes('configuration')" />
</template>

<style lang="scss" scoped>
@import '@/assets/style/helpers/include-media';

.header {
  transition: background 0.8s ease;

  .header__title {
    height: auto;
    overflow: visible;
    @include media('<tablet') {
      margin-right: rem-calc(8);
    }
  }

  &__user-wrap {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-left: auto;
  }

  &__user {
    display: flex;
    align-items: center;
  }

  &__icon {
    font-size: rem-calc(24);
    margin-right: rem-calc(12);
  }

  .lang-switcher {
    padding-left: rem-calc(32);
  }

  .has--pointer {
    cursor: pointer;
    user-select: none;
  }

  a {
    color: #fff;
    text-decoration: none;
  }
}
</style>
